module.exports = __webpack_public_path__ + "img/beneficio-3.d2248c5b.svg";